import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import DcrgfList from '../../components/lrf/listar/dcrgf';


function DcrgfScreen () {
    return (
        <Fragment>
            <Head titulo="Demonstrativo Consolidado do Relatório de Gestão Fiscal - DCRGF"/>
            <Header />
            <Container>
                <DcrgfList />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DcrgfScreen;